import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import React, { useCallback, useContext } from 'react'
import Sheet from 'components/utils/Sheet'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { useAppSelector } from 'hooks/reduxHooks'

interface Props {
  loggedIn: boolean
}
function TripLandingPageHeader(props: Props) {
  const showModal = useContext(ModalContext)
  const isTripChatPageEnabled = useOptimizelyExperiment(OptimizelyFeatureFlags.trpTripChatPage)
  const deviceType = useAppSelector(state => state.system.device.deviceType)
  const isDesktop = deviceType !== 'mobile' && deviceType !== 'tablet'
  const showAITripPlanner = isTripChatPageEnabled && isDesktop

  const onLoginClick = useCallback(() => {
    showModal(<AccountAccessModal />)
  }, [showModal])

  const contentWithFeatureFlag = (
    <Group direction="vertical" gap={16} desktopDirection="horizontal" verticalAlign="center" desktopHorizontalAlign="space-between" desktopGap={24}>
      <Group direction="vertical" gap={16}>
        <Group direction="vertical" gap={8}>
          <StatusLabel
            variant="confirmation"
            startIcon={<SolidSparklesIcon />}
          >
            AI Trip Planner
          </StatusLabel>
          <HeadingTextBlock variant="heading1">
            <Heading variant="heading1">
              The <i>easiest</i> way
            </Heading>
            <Heading variant="heading1">
              to plan a holiday, ever
            </Heading>
          </HeadingTextBlock>
          <BodyText variant="large">
            We combine expert travel knowledge with powerful AI <CSSBreakpoint as="br" min="tablet" />to make trip planning effortless, smart and fun.
          </BodyText>
        </Group>
        <Group direction="vertical" gap={16} verticalAlign="center" horizontalAlign="start">
          <TextButton kind="primary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to="/trip-planner/generate-trip">
            Start planning - It's free
          </TextButton>
          {!props.loggedIn && <BodyText variant="medium" weight="bold"> Already have trips? <TextLink onClick={onLoginClick}> Log in</TextLink> </BodyText>}
        </Group>
      </Group>
      <Sheet padding="20 16" tabletPadding={24} background="neutral-eight" borderRadius="L" paletteType="default">
        <Group direction="vertical" gap={4}>
          <BodyText variant="medium" weight="bold" colour="highlight-secondary">
            You've been invited to try our
          </BodyText>
          <Group direction="horizontal" gap={12}>
            <Heading variant="heading3" colour="neutral-one">
              New AI TripPlanner
            </Heading>
            <StatusLabel variant="confirmation"> Beta </StatusLabel>
          </Group>
          <Group direction="vertical" gap={8}>
            <BodyText variant="medium">
              Chat with your personal travel designer who
              will help<br /> craft the perfect itinerary for you.
            </BodyText>
            <TextButton kind="primary" size="large" to="/trip-planner/chat-trip-planner">
              Give it a go
            </TextButton>
          </Group>
        </Group>
      </Sheet>
    </Group>
  )

  const contentWithoutFeatureFlag = (
    <Group direction="vertical" gap={32} desktopGap={40} desktopDirection="horizontal" desktopHorizontalAlign="space-between">
      <Group direction="vertical" gap={8}>
        <StatusLabel
          variant="confirmation"
          startIcon={<SolidSparklesIcon />}
        >
          AI Trip Planner
        </StatusLabel>
        <HeadingTextBlock variant="heading1">
          <Heading variant="heading1">
            The <i>easiest</i> way
          </Heading>
          <Heading variant="heading1">
            to plan a holiday, ever
          </Heading>
        </HeadingTextBlock>
        <BodyText variant="large">
          We combine expert travel knowledge with powerful AI <CSSBreakpoint as="br" min="tablet" />to make trip planning effortless, smart and fun.
        </BodyText>
      </Group>
      <Group direction="vertical" gap={16} verticalAlign="center" horizontalAlign="start" desktopHorizontalAlign="center">
        <TextButton kind="primary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to="/trip-planner/generate-trip">
          Start planning - It's free
        </TextButton>
        {!props.loggedIn && <BodyText variant="medium" weight="bold"> Already have trips? <TextLink onClick={onLoginClick}> Log in</TextLink> </BodyText>}
      </Group>
    </Group>
  )

  return (
    <Sheet
      paletteType="inverse"
      style={{ position: 'relative' }}
    >
      {showAITripPlanner ? contentWithFeatureFlag : contentWithoutFeatureFlag}
    </Sheet>
  )
}

export default TripLandingPageHeader
